/** Cheap DIY plant photo ID. Distinct from the Species Identification Review guided pack. */

export const PLANT_SPECIES_ID_SLUG = "plant-species-id";
export const PLANT_SPECIES_ID_RESOURCE_ID = "res_plant_species_id";
export const PLANT_SPECIES_ID_REPORT_TYPE_ID = "rt_plant_species_id";
export const SPECIES_ID_REVIEW_SLUG = "species-id-review";

/** A$149.00 incl. GST (A$135.45 + A$13.55 GST). Same money helper as other DIY paid tools. */
export const PLANT_SPECIES_ID_PRICE_CENTS = 14_900;

/** DIY catalogue ceiling once this SKU sits above the ~A$99 PDFs. */
export const DIY_TOOLS_MAX_CENTS = PLANT_SPECIES_ID_PRICE_CENTS;

export const PLANT_SPECIES_ID_PREFERRED_PHOTOS = 3;
export const PLANT_SPECIES_ID_MIN_PHOTOS = 1;

export const PLANT_SPECIES_ID_PHOTO_KINDS = [
  "plant_photo_1",
  "plant_photo_2",
  "plant_photo_3",
] as const;

export type PlantPhotoKind = (typeof PLANT_SPECIES_ID_PHOTO_KINDS)[number];

export const PLANT_SPECIES_ID = {
  slug: PLANT_SPECIES_ID_SLUG,
  name: "Plant species ID",
  summary:
    "Need 3 photos to identify, if available. Common name and scientific name when the photos support it.",
  description:
    "Upload photos of one plant. Need 3 photos to identify, if available. If you have fewer than 3, upload what you have. ID confidence drops. We return a common name and scientific name when the photos support it. We do not invent a species if the photos are poor. This is a DIY photo intake (A$149.00 incl. GST), not the Species Identification Review guided pack.",
  photoCopy: "Need 3 photos to identify, if available.",
  fewerCopy: "If you have fewer than 3, upload what you have. ID confidence drops.",
  deliveryCopy:
    "Common name and scientific name when the photos support it. We do not invent a species if the photos are poor.",
  distinctFrom: "This is not the Species Identification Review guided pack.",
  checkoutDescription: "DIY photo intake. Ecological Engineering.",
} as const;

export function isPlantSpeciesIdSlug(slug: string | null | undefined): boolean {
  return slug === PLANT_SPECIES_ID_SLUG;
}

export function isSpeciesIdReviewSlug(slug: string | null | undefined): boolean {
  return slug === SPECIES_ID_REVIEW_SLUG;
}

export function isPlantPhotoKind(kind: string | null | undefined): kind is PlantPhotoKind {
  return !!kind && (PLANT_SPECIES_ID_PHOTO_KINDS as readonly string[]).includes(kind);
}

export function countPlantPhotos(
  files: Array<{ kind?: string | null; contentType?: string | null; content_type?: string | null }>
): number {
  const slots = new Set<string>();
  for (const file of files) {
    if (isPlantPhotoKind(file.kind)) {
      slots.add(file.kind);
    }
  }
  return slots.size;
}

export function plantSpeciesIdCheckoutLine(unitAmountCentsInclGst = PLANT_SPECIES_ID_PRICE_CENTS) {
  return {
    name: PLANT_SPECIES_ID.name,
    description: PLANT_SPECIES_ID.checkoutDescription,
    unitAmountCentsInclGst,
  };
}
